import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState, useEffect } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";
import {
  addListener,
  applyMiddleware,
  asyncThunkCreator,
} from "@reduxjs/toolkit";

function UpgradeByAdmin() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [activamount, setActivation] = useState("");
  const [name, setName] = useState("");

  const [utr, setUtr] = useState("");
  const [usd, setUsd] = useState(0);
  const [Planid, setPlanid] = useState("1");
  const [PlanAmount, setPlanAmount] = useState("");

  const [Plans, setPlans] = useState([]);
  const [PlanAmountList, setPlanAmountList] = useState([]);
  const [remark, setremark] = useState("");

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setSearch(limitedValue);
    CheckUserId_Api(limitedValue);
  };

  const plans_api = async () => {
    try {
      let res = await API.get(
        "/getplans",
        { loginid: userId },
        { headers: { Authorization: jwt_token } }
      );
    } catch (error) {}
  };
  const CheckUserId_Api = async (value) => {
    try {
      let res = await API.post(
        "/CheckUserId",
        {
          loginid: userId,
          uid: value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("cuser_Api", res.data);
      if (res?.data?.data === "WrongId") {
        setName("Wrong Id");
      } else {
        setSearch(value);
        setName("Valid ID");
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleAmount = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      ""
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setActivation(limitedValue);
    setUsd(limitedValue);
  };

  const checkPlan = (e) => {
    const selectedPlanId = Number(e.target.value);
    setPlanid(selectedPlanId);
    PlanAmout_API(selectedPlanId);
  };
  const checkPlanAmount = (e) => {
    const selectedPlanId = Number(e.target.value);
    setPlanAmount(selectedPlanId);
  };

  const PlanList_API = async () => {
    try {
      let res = await API.get(`PlanList`);
      const fetchedPlans = res.data.data[0];
      setPlans(fetchedPlans);
    } catch (error) {
      console.log("Plan API ERROR", error);
    }
  };
  const PlanAmout_API = async (rowid) => {
    try {
      let response = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: rowid,
          fdate: "",
          tdate: "",
          report: "Plan",
          status: "2",
          level: "0",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //  console.log("responseCountryId-->",CountryId, response.data.data[0]);
      const fetchedStates = response.data.data[0];
      setPlanAmountList(fetchedStates);
    } catch (e) {
      console.log("Error While calling getregion API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        sessionStorage.clear();
        localStorage.clear();
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/Upgrade",
        {
          loginid: userId,
          userId: search,
          referBy: "Admin",
          Amount: usd,
          actype: "Normal Activation",
          AdminRemark: remark,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      console.log("My_Team", responceRight.data);
      if (responceRight.data.data.RESULT === "Successfully Upgrade !!") {
        toast.success(responceRight.data.data.RESULT);
        setActivation("");
        setSearch("");
        setName("");
        setPlanAmount("");
        setPlanid("");
        setremark("");
        setUsd("");
      } else {
        toast.error(responceRight.data.data.RESULT);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  // useEffect(() => {
  //   PlanList_API();
  //   PlanAmout_API(1);
  // }, []);
  return (
    <div>
      <Navbar />
       {userId === "1" ? (
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Upgrade</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1>Upgrade</h1>
                                  <Link
                                    to="/Activationhistory"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}
                                  >
                                    Activation/Upgrade History
                                  </Link>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={search}
                                    onChange={handleChange}
                                  />
                                  {/* {name && <p>{name}</p>} */}
                                  {name && (
                                    <p
                                      className={
                                        name === "Wrong Id"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {name}
                                    </p>
                                  )}
                                </div>

                                <div class="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={activamount}
                                    onChange={handleAmount}
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Txn</label>
                                  <input
                                    type="text"
                                    maxLength={20}
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Remark"
                                    value={utr}
                                    onChange={(e) => setUtr(e.target.value)}
                                  />
                                </div> */}

                                {/*                                 
                                <div className="form-group">
                                  <label>Select Plan</label>
                                  <select
                                    name="Plan"
                                    className="form-control"
                                    value={Planid}
                                    onChange={checkPlan}
                                  >
                                    <option value="" disabled>
                                      Select Plan
                                    </option>
                                    {Plans.map((Plan) => (
                                      <option
                                        key={Plan.id}
                                        value={Plan.Id.toString()}
                                      >
                                        {Plan.PlanName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="form-group">
                                  <label>Select Plan</label>
                                  <select
                                    name="Plan"
                                    className="form-control"
                                    value={PlanAmount}
                                    onChange={checkPlanAmount}
                                  >
                                   

                                    <option value="" disabled>
                                      Select Amount
                                    </option>
                                    {PlanAmountList.map((Plan) => (
                                      <option
                                        key={Plan.id}
                                        value={Plan.PlanAmount.toString()}
                                      >
                                        {Plan.PlanAmount}
                                      </option>
                                    ))}
                                  </select>
                                </div> */}

                                <div className="form-group">
                                  <label>Remark</label>
                                  <input
                                    type="text"
                                    maxLength={50}
                                    class="form-control"
                                    placeholder="Enter Remark"
                                    value={remark}
                                    onChange={(e) => setremark(e.target.value)}
                                  />
                                </div>
                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => referral_API()}
                                  >
                                    Upgrade{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ) : (
        <>
          <div class="content-page">
            <div class="content">
              <div class="row">
                <div class="col-md-12">
                  <div class="panel panel-primary">
                    <div class="panel-heading">
                      <h4 class="panel-title">Upgrade</h4>
                    </div>
                    <div className="text-center mt-5">
                      <h3>You are not authorized to access this page.</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
export default UpgradeByAdmin;
